import NProgress from 'nprogress'; //导入进度条插件
import 'nprogress/nprogress.css';
NProgress.configure({ showSpinner: false });
export {NProgress};


// WEBPACK FOOTER //
// ./src/util/nprogress.js